import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = { message: String }

  declare messageValue: string

  connect(): void {
    this.element.addEventListener('turbo:frame-missing', this.handleError)
    this.element.addEventListener('turbo:fetch-request-error', this.handleError)
  }

  disconnect(): void {
    this.element.removeEventListener('turbo:frame-missing', this.handleError)
    this.element.removeEventListener(
      'turbo:fetch-request-error',
      this.handleError
    )
  }

  private handleError = (event: Event): void => {
    event.preventDefault()

    this.element.innerHTML = `
      <div class="sf-grid">
        <div class="sf-row sf-row-center">
          <div class="sf-col sf-col-xs-10">
            <div class="sf-layer-empty">${this.escapeHtml(
              this.messageValue
            )}</div>
          </div>
        </div>
      </div>
    `
  }

  private escapeHtml(text: string): string {
    const div = document.createElement('div')
    div.textContent = text
    return div.innerHTML
  }
}
